import TableItemsList from "./TableItemsList";

export default TableItemsList;
